import { useEffect } from "react";
import Feature from "ol/Feature";
import { Geometry } from "ol/geom";
import { FeatureCollection, FeatureFromGeojson } from "../../FeaturesStore";

interface UseTranslateHandleSyncOptions {
  isActive: boolean;
  geoJson: FeatureCollection;
  selectedFeature: FeatureFromGeojson | null | undefined;
  findFeatureById: (id: string) => Feature<Geometry> | null;
  installTranslate: (feature: Feature<Geometry>) => void;
  removeTranslate: () => void;
}

/**
 * isActive 상태와 GeoJSON의 isMoving 플래그를 기반으로
 * OL Translate 핸들의 설치/해제를 자동으로 동기화합니다.
 */
export function useTranslateHandleSync({
  isActive,
  geoJson,
  selectedFeature,
  findFeatureById,
  installTranslate,
  removeTranslate,
}: UseTranslateHandleSyncOptions) {
  // 이동 모드 비활성화 시 핸들 제거
  useEffect(() => {
    if (!isActive) {
      removeTranslate();
    }
  }, [isActive, removeTranslate]);

  // isMoving 플래그 기반으로 이동 핸들 설치
  useEffect(() => {
    if (!isActive) return;
    const movingTarget = geoJson.features.find((f) => f.properties?.isMoving);
    if (!movingTarget) {
      removeTranslate();
      return;
    }
    const feature = findFeatureById(String(movingTarget.id));
    if (feature) installTranslate(feature);
  }, [isActive, geoJson, findFeatureById, installTranslate, removeTranslate]);

  // 이동 모드 진입 직후 selectedFeature에 즉시 핸들 설치
  useEffect(() => {
    if (!isActive || !selectedFeature?.id) return;
    const feature = findFeatureById(String(selectedFeature.id));
    if (feature) installTranslate(feature);
  }, [isActive, selectedFeature, findFeatureById, installTranslate]);
}
